import styled from 'styled-components';

import { overlay } from 'styled';

export const Item = styled.div`
  background: #ffffff;

  transition: all 0.4s;

  cursor: pointer;

  &:hover {
    background: #fafafa;
  }
`;

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e1e1e1;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    path {
      fill: #ffffff;
    }
  }
`;

export const Content = styled.div`
  width: 300px;

  display: flex;
  flex-direction: column;

  gap: 6px;

  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0px;
  }

  .ant-pagination-options {
    display: none;
  }
`;

export const ResultWrapper = styled.div`
  max-height: 360px;

  overflow: scroll;
  overflow-x: hidden;

  ${overlay}
`;
